import * as React from 'react'
import { BulkActionButton } from '../BulkActionButton'

type Props = { hasPermission: boolean }
export const BulkReopenButton: React.FC<Props> = (props) => (
  <BulkActionButton
    type="reopen"
    helperText="Re-open closed records in bulk. Records must be in a closed state to perform this action."
    hasPermission={props.hasPermission}
    errorString="You do not have permission to perform bulk updates."
    dataTestId="reopen"
  >
    Re-Open
  </BulkActionButton>
)
BulkReopenButton.displayName = 'BulkReopenButton'
